export * from './locations'
export * from './analytics'
export * from './signin'
export * from './reviews'
export * from './reviewsAuth'
export * from './recommendations'
export * from './rewards'
export * from './chat'
export * from './devices'

import { getWidgetConfig } from '@/config'

// eslint-disable-next-line prefer-const -- must be mutable for runtime config injection
export let API_BASE = process.env.API_BASE || ''

export function initApiBase(): void {
  const config = getWidgetConfig()
  if (config?.apiBase) {
    API_BASE = config.apiBase
  }
}
